import React, { Component } from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { connect } from 'react-redux';
import {
  FormGroup,
  FormControl,
} from 'react-bootstrap';
import _ from 'lodash';

import validate from '../../lib/validation';

import { updateField } from '../../actions/form';

export class DateRangePickerDesktop extends Component {
  constructor(props) {
    super(props);

    this.defaultValue = new Date();
    this.onInputChange = this.onInputChange.bind(this);
    this.updateStore = this.updateStore.bind(this);
  }

  componentDidMount() {
    if (_.isEmpty(this.props.fieldValue)) {
      this.updateStore(this.defaultValue);
    }
  }

  onInputChange(value) {
    this.updateStore(value);
  }

  updateStore(value) {
    this.props.updateField(this.props.type, this.props.field, value);
  }

  validateDates() {
    const startDateIsValid = validate.run({ type: 'Date' }, this.props.fieldValue[0]);
    const endDateIsValid = validate.run({ type: 'Date' }, this.props.fieldValue[1]);
    if (startDateIsValid && endDateIsValid) return 'success';
    return 'error';
  }

  render() {
    return (
      <React.Fragment>
        <FormGroup validationState={this.validateDates()}>
          <DateRangePicker
            onChange={this.onInputChange}
            value={this.props.fieldValue}
            clearIcon={null}
            required
          />
          <FormControl.Feedback />
        </FormGroup>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state, ownProps) => {
  return {
    fieldValue: _.get(state, `form.${state.ui.ratingType}.fields.${ownProps.field}`, new Date()),
    type: _.get(state, 'ui.ratingType'),
  };
};

export default connect(
  mapStateToProps,
  { updateField },
)(DateRangePickerDesktop);
